export default (state, action) => {
  switch (action.type) {
    case "SET_TRANSACTION_LOADER":
      return { ...state, transactionLoader: action.payload };
    case "SET_USER_DATA":
      return { ...state, userData: action.payload };
    default:
      return state;
  }
};
